import { stringify } from '@angular/compiler/src/util';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { HokHeaderItem } from 'ClientApp/app/modules/direct-debit/interfaces/IGetHokDetailsForAllCard.interface';
import { Subscription } from 'rxjs/Subscription';
import { GtmService } from '../../../../../../shared/cardholders-core/services/gtm.service';
import { IFilterUsers, IFilterState, IFilterCard, IFilterBank, EHokStatus } from '../../interfaces/filters.interface';
import { DebitListService } from '../../services/main-debit-list.service';
import { ExcelService } from '../../services/excel.service';
import { UiHelperService } from 'ClientApp/app/shared/cardholders-core/services/ui-helper.service';

export enum FilterType {
    Card,
    Status,
    User,
    None
}
@Component({
    selector: 'app-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit, OnDestroy {
    openCombo = FilterType.None;
    EHokStatus = EHokStatus;
    FilterType = FilterType;
    users: IFilterUsers[];
    state: IFilterState;
    banks: IFilterBank[];
    subs: Subscription[] = [];
    totalCard: number;
    hoks: HokHeaderItem[] = [];
    constructor(
        private debListSrv: DebitListService,
        private helper: UiHelperService,
        public gtmService: GtmService,
        private excelSrv: ExcelService
    ) {}
    ngOnDestroy(): void {
        this.subs.forEach((x) => x.unsubscribe());
    }

    ngOnInit(): void {
        this.subs.push(
            this.debListSrv.getAllUsers().subscribe((x) => {
                this.users = x ?? [];
            })
        );
        this.subs.push(
            this.debListSrv.state.subscribe((x) => {
                this.state = x;
            })
        );
        this.subs.push(
            this.debListSrv.getAllBankAndCard().subscribe((x) => {
                if (x) {
                    this.banks = x;
                    this.totalCard = this.gettotalCard();
                }
            })
        );
        this.subs.push(
            this.debListSrv.getAllHokByState().subscribe((x) => {
                this.hoks = x ?? [];
            })
        );
        this.subs.push(
            this.debListSrv.filterOpen$.subscribe((x) => {
                if (!x) {
                    this.openCombo = FilterType.None;
                }
            })
        );
        if (this.helper.isBrowser && !this.helper.detectIE()) {
            const filterTag: any = document.getElementsByTagName('app-filter')[0];
            filterTag.style.position = 'sticky';
            filterTag.style.position = '-webkit-sticky';
            filterTag.style.top = `${window.innerWidth < 768 ? '68' : '70'}px`;
            filterTag.style.backgroundColor = 'white';
            filterTag.style.display = 'block';
            filterTag.style.zIndex = 3;
        }
    }
    getActivateCard(bank: IFilterBank, activeStatus: boolean): IFilterCard[] {
        return bank.cards.filter((card) => (activeStatus ? card.activeStatus !== 0 : card.activeStatus === 0)) ?? [];
    }
    gettotalCard(): number {
        let count = 0;
        this.banks.forEach((bank) => {
            count += bank.cards.length;
        });

        return count;
    }
    selectCombo(type: FilterType): void {
        if (this.openCombo === FilterType.None) {
            this.debListSrv.filterOpen$.next(true);
            this.openCombo = type;
        } else {
            this.closePopup();
        }
    }
    closePopup(): void {
        setTimeout(() => {
            this.debListSrv.filterOpen$.next(false);
            this.openCombo = FilterType.None;
        }, 100);
    }
    selectUser(user: IFilterUsers): void {
        this.gtmService.pushDirectDebitList('filters', 'filter-user');

        this.closePopup();

        this.debListSrv.state.next({ ...this.debListSrv.state.getValue(), selectedUser: user, selectedCard: null, bankAccount: null });
    }
    selectCard(card: IFilterCard): void {
        this.gtmService.pushDirectDebitList('filters', 'Filter card');
        this.closePopup();

        this.debListSrv.state.next({ ...this.debListSrv.state.getValue(), bankAccount: null, selectedCard: card !== null ? [card] : null });
    }
    selectCardsByBankId(bank: IFilterBank): void {
        this.closePopup();

        this.debListSrv.state.next({...this.debListSrv.state.getValue(), bankAccount: bank, selectedCard: bank.cards});
    }
    selectStatus(status: EHokStatus): void {
        this.gtmService.pushDirectDebitList('filters', 'Filter status-' + status.toString().toLocaleLowerCase());
        this.closePopup();

        this.debListSrv.state.next({ ...this.debListSrv.state.getValue(), selectedStatus: status });
    }
    getStatusName(status: EHokStatus): string {
        return this.debListSrv.getStatusName(status);
    }
    getAllStatus(): { name: string; type: EHokStatus }[] {
        return Object.entries(EHokStatus).map((x) => {
            return { name: x[0], type: x[1] };
        });
    }

    onPrint(): void {
        window.print();
    }
    exportToExcel(): void {
        this.excelSrv.exportAsExcelFile(this.hoks, this.state, 'direct-debit', this.users.length, this.totalCard);
    }
}
